(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linktree"]) return;
  try {
    
  var clickhide = function(e) {
    $("#linktree-item-subscriber").hide();
    $("#mailchimp-embedded-form-subscriber").show();
  }
  var clickshow = function(e) {
    $("#linktree-item-subscriber").show();
    $("#mailchimp-embedded-form-subscriber").hide();
  }

  $(document).on('click', function(e) {
    var target = $(e.target);
    if (target.is('#mailchimp-embedded-form-subscriber *')) {
      return
    } else if (target.is("#linktree-item-subscriber *")) {
      clickhide();
    } else {
      clickshow();
    }
  })

  } catch(e) { console.error(e); }
})();
})();
